export const LOCAL_STORAGE = {
  key: 'AGEAS/PETIS',
  fillDataForSimulation: 'fillDataForSimulation',
  entity: 'entity',
  entitySelected: 'entitySelected',
  breeds: 'breeds',
  policyHolderReferenceData: 'policyHolderReferenceData',
  animalStore: 'animalStore',
  initialDate: 'initialDate',
  prospectEntity: 'prospectEntity',
}
